import { Sun, Moon, MonitorCog } from "lucide-react";
import { cn } from "@lib/utils";
import { Button } from "@primitives/button";
import { useThemeState } from "@/zustand/ThemeState";
import { useTranslation } from "react-i18next";

export default function ColorModeSection() {
  const { t } = useTranslation();
  const { colorMode, setColorMode } = useThemeState();
  return (
    <div className="mt-2 py-2">
      <h5 className="mb-2 text-xs font-light text-foreground/50">
        {t("appearance.colorMode")}
      </h5>

      <div className="grid grid-cols-3 gap-3">
        <Button
          onClick={() => setColorMode("light")}
          variant="outline"
          className={cn(
            "flex h-20 flex-col items-center rounded-md border-border p-1 align-middle text-foreground",
            colorMode === "light" && "border-primary shadow-md",
          )}
        >
          <Sun className="size-5" />
          <span className="text-sm font-normal">{t("appearance.light")}</span>
        </Button>
        <Button
          onClick={() => setColorMode("dark")}
          variant="outline"
          className={cn(
            "flex h-20 flex-col items-center rounded-md border-border p-1 align-middle text-foreground",
            colorMode === "dark" && "border-primary shadow-md",
          )}
        >
          <Moon className="size-5" />
          <span className="text-sm font-normal">{t("appearance.dark")}</span>
        </Button>
        <Button
          onClick={() => setColorMode("system")}
          variant="outline"
          className={cn(
            "flex h-20 flex-col items-center rounded-md border-border p-1 align-middle text-foreground",
            colorMode === "system" && "border-primary shadow-md",
          )}
        >
          <MonitorCog className="size-5" />
          <span className="text-sm font-normal">{t("appearance.system")}</span>
        </Button>
      </div>
    </div>
  );
}
